import { Fragment, Node, Slice } from '@tiptap/pm/model'

/**
 * A helper for ProseMirror transform* methods that allows
 * you to append nodes based on the properties of each node
 * in the slice.
 */
const appendNodeTransform = (
  slice: Slice,
  callback: (node: Node, index: number, fragment: Fragment) => Node | null
) => {
  const fragment = slice.content
  const nodes: Node[] = []
  fragment.nodesBetween(0, fragment.size, (node, start, parent, index) => {
    nodes.push(node)

    let result: Node | null
    if ((result = callback(node, index, fragment)) !== null) {
      nodes.push(result)
    }

    return false
  })

  return Slice.maxOpen(Fragment.fromArray(nodes))
}

export default appendNodeTransform
